<script lang="ts">
  import { createBubbler } from "svelte/legacy";

  const bubble = createBubbler();
  import Arrow from "./Arrow.svelte";
  interface Props {
    arrowPosition?: "right" | "left";
    href?: string;
    class?: string;
    children?: import("svelte").Snippet;
    onClick?: () => void;
  }

  let {
    arrowPosition = "right",
    href = undefined,
    class: className,
    children,
    onClick,
  }: Props = $props();
</script>

{#if href}
  <a
    {href}
    class="text-Violet700 group text-S sm:text-M inline-flex items-center {className}  {arrowPosition ==
    'left'
      ? 'flex-row-reverse text-left'
      : 'text-right'} "
  >
    {@render children?.()}
    <Arrow
      class="flex-shrink-0 transition transform group-hover:translate-x-0.5 {arrowPosition == 'left'
        ? 'mr-2'
        : 'ml-2'}"
    />
  </a>
{:else}
  <button
    type="button"
    onclick={onClick}
    class="text-Violet700 group text-S sm:text-M flex items-center {className}  {arrowPosition ==
    'left'
      ? 'flex-row-reverse text-left'
      : 'text-right'} "
  >
    {@render children?.()}
    <Arrow
      class="flex-shrink-0 transition transform group-hover:translate-x-0.5 {arrowPosition == 'left'
        ? 'mr-2'
        : 'ml-2'}"
    />
  </button>
{/if}
